/*スムーススクロール*/
$(function(){
   $("a[href ^='#']:not(.noscroll)").click(function() {
      var speed = 400; // ミリ秒
      var href= $(this).attr("href");
      var target = $(href == "#" || href == "" ? 'html' : href);
      var position = target.offset().top;
      $('body,html').animate({scrollTop:position}, speed, 'swing');
      return false;
   });
});


//ページトップへ
$(function() {
	var topBtn = $('#pageTop');	
	topBtn.hide();
	//スクロールが100に達したらボタン表示
	$(window).scroll(function () {
		if ($(this).scrollTop() > 100) {
			topBtn.fadeIn();
		} else {
			topBtn.fadeOut();
		}
	});
	//スクロールしてトップ
    topBtn.click(function () {
		$('body,html').animate({
			scrollTop: 0
		}, 500);
		return false;
    });
});


/* menu btn*/
$(function() {
 var state = false;
 var pos;
   $('#menu').click(function() {
         $(this).toggleClass("active");
         $('header').toggleClass("active");
    //
 if (state == false) {
 pos = $(window).scrollTop();
 $('body').addClass("fixed").css({'top': -pos});
 state = true;
 } else {
 $('body').removeClass("fixed").css({'top': 0});
 window.scrollTo(0, pos);
 state = false;
 }
   });
   
	$('header .mainNav li span').click(function() {
         $('#menu').removeClass("active");
         $('header').removeClass("active");
    //
 if (state == false) {
 pos = $(window).scrollTop();
 $('body').addClass("fixed").css({'top': -pos});
 state = true;
 } else {
 $('body').removeClass("fixed").css({'top': 0});
 window.scrollTo(0, pos);
 state = false;
 }
   });
	
  $('.jsfilterNav span').click(function() {
   $("html,body").animate({scrollTop:$('#topActivities').offset().top});
  });
   
});

/* header*/
$(function() {    
    //ロード or スクロールされると実行
    $(window).on('load scroll', function(){        
        //スクロールするとfixedクラスを追加
        if ($(window).scrollTop() > 300) {
            $('header').addClass('fixed');
        } else {
            //fixedクラスを削除
            $('header').removeClass('fixed');
        }
        
    });
    
});

/*filter*/
$(function() {
  $('.jsfilterNav span').click(function() {
    var value = $(this).attr('data-filter');
    if (value == 'all') {
      $('.fItem').show(1000);
    } else {
      $('.fItem').not('.'+value).hide(1000);
      $('.fItem').filter('.'+value).show(1000);
    }
    $(document).on('click', '.jsfilterNav span', function () {
      $('.jsfilterNav span').removeClass('active');
      $(this).addClass('active');
			$('[data-filter='+value+']').addClass('active');
    });
  });
	});

$(function() {
	/*下層テンプレートからのリンク*/
	$('.jsfilterNavTemp span').click(function() {
		var sortval = $(this).attr('data-filter');
var obj = $(this).parent('a');
    var link = obj.attr("href");
    obj.attr("href",link+"?sort="+sortval)

	});	
	
});